"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decryptor = void 0;
const crypto_1 = __importDefault(require("crypto"));
const constants_1 = require("./constants");
const errors_1 = require("../errors");
class Decryptor {
    static decrypt(data, password) {
        const kdfparams = data.kdfparams;
        const salt = Buffer.from(data.salt, "hex");
        const iv = Buffer.from(data.iv, "hex");
        const ciphertext = Buffer.from(data.ciphertext, "hex");
        const derivedKey = kdfparams.generateDerivedKey(Buffer.from(password), salt);
        const derivedKeyFirstHalf = derivedKey.slice(0, 16);
        const derivedKeySecondHalf = derivedKey.slice(16, 32);
        const computedMAC = crypto_1.default.createHmac(constants_1.DigestAlgorithm, derivedKeySecondHalf).update(ciphertext).digest();
        const actualMAC = data.mac;
        if (computedMAC.toString("hex") !== actualMAC) {
            throw new errors_1.Err("MAC mismatch, possibly wrong password");
        }
        const decipher = crypto_1.default.createDecipheriv(data.cipher, derivedKeyFirstHalf, iv);
        return Buffer.concat([decipher.update(ciphertext), decipher.final()]);
    }
}
exports.Decryptor = Decryptor;
//# sourceMappingURL=decryptor.js.map